import React from 'react';
import styled from 'styled-components';
import media from '../../utils/media';
const DropdownContainer = styled.div `
  position: absolute;
  right: 0;
  top: 101%;
  transition: all 0.3s ease;
  transform: ${({ shouldDisplayDropdown }) => (shouldDisplayDropdown ? 'scaleY(1)' : 'scaleY(0)')};
  transform-origin: top;
  -webkit-overflow-scrolling: touch;

  ${media.tablet} {
    width: 100%;
  }

  ${media.smallDesktop} {
    height: ${({ shouldDisplayDropdown, dropdownOffset }) => shouldDisplayDropdown ? `calc(100vh - ${dropdownOffset}px)` : '0vh'};
    overflow: hidden;
    transform: none;
  }
`;
// Dropdown panel does not care about its children, it will only render its children
export const DropdownPanel = ({ children, shouldDisplayDropdown, dropdownOffset }) => {
    // TODO: Detect Outside click with useRef to toggle Dropdown
    if (!children)
        return null;
    return (React.createElement(DropdownContainer, { dropdownOffset: dropdownOffset, shouldDisplayDropdown: shouldDisplayDropdown }, children));
};
